export default "__VITE_ASSET__BXnwDl_6__"